import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'checkEmpty'
})
export class CheckEmptyPipe implements PipeTransform {

    transform(value: unknown): any {
        return value===undefined||value===null? 'N/A' : value
    }
}
